import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['record', 'transcribe', 'restricted', 'memberOptions']

  connect() {
    this.sync()
    this.syncAccess()
  }

  sync() {
    const recording = this.recordTarget.checked
    this.transcribeTarget.disabled = !recording
    if (!recording) this.transcribeTarget.checked = false
  }

  syncAccess() {
    this.memberOptionsTarget.classList.toggle('hidden', !this.restrictedTarget.checked)
  }
}
